// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f84fb7c6","43":"bc7db905","175":"31062972","384":"4bc038e9","453":"873ac141","556":"93af2743","569":"b30cbece","942":"cdf241e0","950":"6037335c"}[chunkId] + ".chunk.js";
};